<template>
  <div class="h-100 px-4">
    <div class="pb-2">
      <VSkeletonLoader
        class="w-100"
        type="card-heading"
      />
    </div>
    <div class="d-flex flex-column h-100">
        <div class="d-flex flex-column align-items-center avatar-wrapper">
          <VSkeletonLoader 
            type="avatar"
            class="d-flex justify-content-center w-50 user-avatar pb-4"
          />
          <VSkeletonLoader
            type="card-heading"
            class="w-50"
          />
        </div>
          <VSkeletonLoader
            type="divider"
            class="pb-1"
          />
          <VSkeletonLoader
            type="list-item-avatar"
            class="pb-5" />
          <VSkeletonLoader
            type="list-item-avatar"
            class="pb-3"
          />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'ViewProfileSkeletonLoader',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { useVuetify } from '../../../composables';

const vuetify = useVuetify();
const isMobile = computed(() => vuetify.breakpoint.xs);
</script>
<style lang="scss" scoped>
::v-deep .avatar-wrapper {
    .v-skeleton-loader.v-skeleton-loader--is-loading {
        .v-skeleton-loader__avatar  {
            height: 64px !important;
            width: 64px !important;
        }
    }
}
</style>
